export default __webpack_public_path__ + "static/char-v-41-41b2a8c18fe1c17d84902f9f04de1e80.webp";